// extracted by mini-css-extract-plugin
module.exports = {"arrowCards":"styles_arrowCards__GJgDC"};